export default (props, vars) => props?.['name'] === 'paragon-one';
